import React from 'react';

//CSS File
import './readytobegin.css';

const ReadyToBegin = () => {

    return (

        <section className='ready-to-begin'>

            <div className='get-started'>

                <h1>Ready to <span>Begin?</span> </h1>

                <h5>Embark on the journey of creating your very own AI-powered assistant effortlessly.</h5>

                <button>
                    Get Started
                </button>

            </div>

        </section>

    )

}

export default ReadyToBegin;